"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import toast from "react-hot-toast";
import { SOFT_DRINKS_API, ALCOHOLIC_DRINKS_API } from "@/constants";
import { useSelector } from "react-redux";
import { AppState } from "@/store/configureStore";
import axios from "axios";

const useFetchProducts = (setProductList: any) => {
	const route = usePathname();
	const isAlcoholCheck = route.includes("/alcohol");
	const location = useSelector((state: AppState) => state.location);

	const mergeProductWithVariant = (parent: any, variant: any) => {
		const mergedVariant = { ...parent, ...variant, parentId: parent.id };
		delete mergedVariant.variants;
		return mergedVariant;
	};

	const extractProducts = (products: any) => {
		return products.flatMap((item: any) => {
			const parentProduct = { ...item, parentId: item.id };
			delete parentProduct.variants;

			const variantProducts =
				item.variants?.map((variant: any) =>
					mergeProductWithVariant(item, variant)
				) || [];

			return [parentProduct, ...variantProducts];
		});
	};

	useEffect(() => {
		if (!location?.activeLocation?.id) return;

		const endpoint = isAlcoholCheck ? ALCOHOLIC_DRINKS_API : SOFT_DRINKS_API;

		const fetchData = async () => {
			try {
				const response = await axios.get(endpoint, {
					params: {
						isAlcohol: isAlcoholCheck,
						branchId: location.activeLocation.id,
					},
				});

				if (isAlcoholCheck) {
					setProductList(extractProducts(response.data.alcoholics));
				} else {
					setProductList(extractProducts(response.data.nonAlcoholics));
				}
			} catch (error: string | any) {
				// console.error("API error", error);
				toast.remove();
				toast.error(`Error: ${error?.response?.data?.error}`);
			}
		};

		fetchData();
	}, [isAlcoholCheck, setProductList, location?.activeLocation?.id]);

	return {};
};

export default useFetchProducts;
